import React from "react";
import styled from "styled-components";
import {CSVLink} from "react-csv";
import {ExportIcon} from "../../../elements/ExportIcon";
import {viewAndSubdivideButtonColour} from "../../../../style/styleConsts";
import {log} from "../../../../logging/logEvent";
import {fractionToPercent} from "../../../performance/PercentageChange";
import {hidePrice} from "../../idea/EntryPrice";

const ExportIdeasLink = styled(CSVLink)`
    margin-left: auto;
    border-radius: 3px;
    :hover {
        background-color: ${viewAndSubdivideButtonColour} ;
    }
    cursor: pointer;
`;

const IdeaExportButton = ({ideas}) => {
    if (!ideas.find(idea => idea.stockCurrency)) {
        return null;
    }

    const exportIdeaData = ideas.map(idea => {
        const {
            ideaId, direction, bloomberg, stockName, openTimestamp, portfolioCount, stockEntryPrice, stockCurrency,
            timeOpen, relativeReturnToday, relativeReturnLifetime
        } = idea;
        const entryPrice = hidePrice(idea) ? "" : stockEntryPrice;
        return {
            "Idea Id": ideaId,
            "Direction": direction,
            "Bloomberg": bloomberg,
            "Stock Name": stockName,
            "Open Timestamp": openTimestamp,
            "Time Open": timeOpen,
            "Entry Price": entryPrice,
            "Currency": stockCurrency,
            "Relative Return % (Today)": fractionToPercent(relativeReturnToday),
            "Relative Return % (Lifetime)": fractionToPercent(relativeReturnLifetime),
            "Portfolio(s)": portfolioCount,
        };
    });
    const isoDateTime = new Date().toISOString();
    const filename = `open-ideas-${isoDateTime}.csv`;
    const onClick = () => {
        log("OpenIdeasDownloaded", { ideaCount: ideas.length, filename });
    };
    return <ExportIdeasLink data={exportIdeaData} filename={filename} onClick={onClick}>
        <ExportIcon padding="4px" height="23px" width="23px"/>
    </ExportIdeasLink>;
};

export default IdeaExportButton;